export default __webpack_public_path__ + "static/media/transfacil_galery_16.030854fc.jpg";